module.exports = __webpack_public_path__ + "static/media/empty.ab9ada8f.png";